import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcGraphComponent renders a bar-graph style icon with optional gradient.
 */
@Component({
  selector: 'ic-graph',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-graph.html',
})
export class IcGraphComponent {
  /** The starting color of the icon gradient. MUST be explicitly passed. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. MUST be explicitly passed. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 1. */
  @Input() opacity = 1;

  /** The width of the icon. Defaults to 16. */
  @Input() width: number | string = 16;

  /** The height of the icon. Defaults to 16. */
  @Input() height: number | string = 16;

  /** Solid color for the icon (CSS color value). When set, overrides defaultColor. */
  @Input() color = '';

  /** Default color used when no gradient is provided. */
  @Input() defaultColor = 'var(--color-icon-deactivated)';

  /** Unique ID for the SVG gradient to avoid collisions. */
  gradientId = `primaryGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if both startColor and endColor are provided and non-empty. */
  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
